<template>
    <!-- Centrado -->
    <div class="flex items-center justify-center h-screen">
        <div class="text-center">
            <h1 class="text-3xl font-bold text-primary">Procesar etiquetas</h1>
            <p class="text-slate mt-2">Sube un archivo CSV</p>
            <input type="file" accept=".csv" />
            <div class="mt-4 flex items-center justify-center">
                <Button variant="primary" class="flex items-center px-4 py-2 text-sm font-bold text-white transition duration-150 ease-in-out bg-green-500 rounded hover:bg-green-700">Procesar</Button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        layout: "empty",    
        data() {
            return {
                file: null
            }
        },
        methods: {
            procesar() {
                console.log("Procesar");
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>